<template>
  <div class="dynamic-banner">
    <img :src="dynamicBanner" alt="" />
    <div class="absolute">
      <div class="title">资讯动态</div>
      <div class="text">获取最新行业新闻 了解畅月物业实时动态</div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import dynamicBanner from '../../../assets/dynamic/dynamicBanner.png'

export default {
  setup() {
    return reactive({
      dynamicBanner:dynamicBanner
    })
  }
};
</script>

<style scoped>
.dynamic-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .dynamic-banner {
    min-width: 1180px;
  }
}
.dynamic-banner img {
  width: 100%;
  height: 628px;
}
.absolute {
  position: absolute;
  top: 40%;
  left: 34%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #fff ;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #fff ;
}
</style>
